import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

// Tailwind CSS
import "./styles/tailwind.css";

// 保留的自定义样式
import "./styles/fonts.css";
import "./styles/backgrounds.css"; // 统一背景色样式
import "vfonts/Lato.css";
import "vfonts/FiraCode.css";

// 插件
import VueRippler from "vue-rippler";
import $ from "jquery";
import VueRealWave from "vue-real-wave";

createApp(App)
  .use(store)
  .use(router)
  .use($)
  .use(VueRippler)
  .use(VueRealWave)
  .mount("#app");
